import { render, staticRenderFns } from "./AutomationList.vue?vue&type=template&id=5d2ab885&"
import script from "./AutomationList.vue?vue&type=script&lang=js&"
export * from "./AutomationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports